/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const cog_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.54 2.434a1.957 1.957 0 0 0 2.908 0l.946-1.038a1.959 1.959 0 0 1 3.41 1.413l-.07 1.4a1.958 1.958 0 0 0 2.05 2.054l1.4-.071a1.959 1.959 0 0 1 1.41 3.41l-1.042.94a1.96 1.96 0 0 0 0 2.909l1.042.94a1.96 1.96 0 0 1-1.413 3.41l-1.4-.071a1.958 1.958 0 0 0-2.056 2.056l.071 1.4a1.959 1.959 0 0 1-3.402 1.41l-.94-1.041a1.96 1.96 0 0 0-2.909 0l-.945 1.04a1.959 1.959 0 0 1-3.406-1.407l.072-1.4a1.958 1.958 0 0 0-2.056-2.056l-1.4.07a1.958 1.958 0 0 1-1.416-3.406l1.041-.94a1.96 1.96 0 0 0 0-2.91l-1.04-.944a1.958 1.958 0 0 1 1.408-3.406l1.4.07a1.958 1.958 0 0 0 2.058-2.06l-.067-1.4A1.959 1.959 0 0 1 9.6 1.396l.94 1.038Z"
      clipRule="evenodd"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
      clipRule="evenodd"
    />
  </svg>
)
export default cog_medium
